import {createSubmitRequestTypes} from "./helpers";

export const REQUEST_CHECKOUT_CART = "CHECKOUT:REQUEST_CHECKOUT_CART";
export const CHECKOUT_CART = createSubmitRequestTypes("CHECKOUT:CHECKOUT_CART");
export const requestCheckoutCart = (accountId) => ({ type: REQUEST_CHECKOUT_CART, accountId });
export const cancelCheckoutCart = () => ({ type: CHECKOUT_CART.CANCEL });

export const REQUEST_CANCEL_CHECKOUT = "CHECKOUT:REQUEST_CANCEL_CHECKOUT";
export const CANCEL_CHECKOUT = createSubmitRequestTypes("CHECKOUT:CANCEL_CHECKOUT");
export const requestCancelCheckout = (accountId, orderId, redirect = true) => ({ type: REQUEST_CANCEL_CHECKOUT, accountId, orderId, redirect });
export const cancelCancelCheckout = () => ({ type: CANCEL_CHECKOUT.CANCEL });

export const REQUEST_ADD_SHIPPING_ADDRESS = "CHECKOUT:REQUEST_ADD_SHIPPING_ADDRESS";
export const ADD_SHIPPING_ADDRESS = createSubmitRequestTypes("CHECKOUT:ADD_SHIPPING_ADDRESS");
export const requestAddShippingAddress = (accountId, orderId) => ({ type: REQUEST_ADD_SHIPPING_ADDRESS, accountId, orderId });
export const cancelAddShippingAddress = () => ({ type: ADD_SHIPPING_ADDRESS.CANCEL });

export const REQUEST_CHANGE_SHIPPING_ADDRESS = "CHECKOUT:REQUEST_CHANGE_SHIPPING_ADDRESS";
export const CHANGE_SHIPPING_ADDRESS = createSubmitRequestTypes("CHECKOUT:CHANGE_SHIPPING_ADDRESS");
export const requestChangeShippingAddress = (accountId, orderId) => ({ type: REQUEST_CHANGE_SHIPPING_ADDRESS, accountId, orderId });
export const cancelChangeShippingAddress = () => ({ type: CHANGE_SHIPPING_ADDRESS.CANCEL });

export const REQUEST_EDIT_SHIPPING_ADDRESS = "CHECKOUT:REQUEST_EDIT_SHIPPING_ADDRESS";
export const EDIT_SHIPPING_ADDRESS = createSubmitRequestTypes("CHECKOUT:EDIT_SHIPPING_ADDRESS");
export const requestEditShippingAddress = (accountId, orderId) => ({ type: REQUEST_EDIT_SHIPPING_ADDRESS, accountId, orderId });
export const cancelEditShippingAddress = () => ({ type: EDIT_SHIPPING_ADDRESS.CANCEL });

export const REQUEST_SHOW_ORDER_STATUS = "CHECKOUT:REQUEST_SHOW_ORDER_STATUS";
export const SHOW_ORDER_STATUS = createSubmitRequestTypes("CHECKOUT:SHOW_ORDER_STATUS");
export const requestShowOrderStatus = (accountId, orderId, status, errorMsg = "", invoiceNr = "") => ({ type: REQUEST_SHOW_ORDER_STATUS, accountId, orderId, status, errorMsg, invoiceNr });
export const cancelShowOrderStatus = () => ({ type: SHOW_ORDER_STATUS.CANCEL });
export const reportShowOrderStatusSuccess = () => ({ type: SHOW_ORDER_STATUS.SUCCESS });

export const REQUEST_ADD_GIFT_MESSAGE = "CHECKOUT:REQUEST_ADD_GIFT_MESSAGE";
export const ADD_GIFT_MESSAGE = createSubmitRequestTypes("CHECKOUT:ADD_GIFT_MESSAGE");
export const requestAddGiftMessage = (orderId) => ({ type: REQUEST_ADD_GIFT_MESSAGE, orderId });
export const cancelAddGiftMessage = () => ({ type: ADD_GIFT_MESSAGE.CANCEL });
export const successAddGiftMessage = () => ({ type: ADD_GIFT_MESSAGE.SUCCESS });

export const REQUEST_EDIT_GIFT_MESSAGE = "CHECKOUT:REQUEST_EDIT_GIFT_MESSAGE";
export const EDIT_GIFT_MESSAGE = createSubmitRequestTypes("CHECKOUT:EDIT_GIFT_MESSAGE");
export const requestEditGiftMessage = (orderId, message) => ({ type: REQUEST_EDIT_GIFT_MESSAGE, orderId, message });
export const cancelEditGiftMessage = () => ({ type: EDIT_GIFT_MESSAGE.CANCEL });
export const successEditGiftMessage = () => ({ type: EDIT_GIFT_MESSAGE.SUCCESS });

export const REQUEST_REMOVE_GIFT_MESSAGE = "CHECKOUT:REQUEST_REMOVE_GIFT_MESSAGE";
export const REMOVE_GIFT_MESSAGE = createSubmitRequestTypes("CHECKOUT:REMOVE_GIFT_MESSAGE");
export const requestRemoveGiftMessage = (orderId) => ({ type: REQUEST_REMOVE_GIFT_MESSAGE, orderId });
export const cancelRemoveGiftMessage = () => ({ type: REMOVE_GIFT_MESSAGE.CANCEL });
export const successRemoveGiftMessage = () => ({ type: REMOVE_GIFT_MESSAGE.SUCCESS });